import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import SuperadminLayout from './SuperadminLayout';
import { Modal, Button } from 'react-bootstrap';
import axios from '../../axios/axiosconf';
import { ordenarListaAlfabetica } from './superadminSortUtils';
import './SuperadminStyles.css';

const PlantillasAdmin = () => {
    const history = useHistory();
    const [plantillas, setPlantillas] = useState([]);
    const [filteredPlantillas, setFilteredPlantillas] = useState([]);
    const [loading, setLoading] = useState(true);
const [searchTerm, setSearchTerm] = useState('');
    const [especialidadFilter, setEspecialidadFilter] = useState('todos');
    const [currentPage, setCurrentPage] = useState(1);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [plantillaToDelete, setPlantillaToDelete] = useState(null);
    const [plantillaToPreview, setPlantillaToPreview] = useState(null);
    const [alert, setAlert] = useState({ show: false, type: '', message: '' });
    const itemsPerPage = 20;

    useEffect(() => {
        const token = localStorage.getItem('superadmin_token');
        const user = localStorage.getItem('superadmin_user');

        if (!token || !user) {
            history.push('/superadmin/login');
            return;
        }
axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        fetchPlantillas();
    }, [history]);

    useEffect(() => {
        let filtered = plantillas;

        // Filtrar por especialidad
        if (especialidadFilter !== 'todos') {
            filtered = filtered.filter(p => p.especialidad === especialidadFilter);
        }

        // Filtrar por búsqueda
        if (searchTerm) {
            filtered = filtered.filter(p =>
                p.nombre.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        setFilteredPlantillas(ordenarListaAlfabetica(filtered, 'nombre'));
        setCurrentPage(1);
    }, [searchTerm, especialidadFilter, plantillas]);

    const fetchPlantillas = async () => {
        try {
            const response = await axios.get('/superadmin/plantillas-admin');
            const ordenadas = ordenarListaAlfabetica(response.data, 'nombre');
            setPlantillas(ordenadas);
            setFilteredPlantillas(ordenadas);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching plantillas:', error);
            if (error.response && error.response.status === 401) {
                localStorage.removeItem('superadmin_token');
                localStorage.removeItem('superadmin_user');
                history.push('/superadmin/login');
            }
            setLoading(false);
        }
    };

    const handleDeleteClick = (plantilla) => {
        setPlantillaToDelete(plantilla);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        try {
            await axios.delete(`/superadmin/plantillas-admin/${plantillaToDelete.id}`);
            setAlert({
                show: true,
                type: 'success',
                message: 'Plantilla eliminada exitosamente'
            });
            fetchPlantillas();
        } catch (error) {
            console.error('Error deleting plantilla:', error);
            setAlert({
                show: true,
                type: 'danger',
                message: error.response?.data?.message || 'Error al eliminar la plantilla'
            });
        } finally {
            setShowDeleteModal(false);
            setPlantillaToDelete(null);
            setTimeout(() => setAlert({ show: false, type: '', message: '' }), 5000);
        }
    };

    const handleDuplicar = async (plantillaId) => {
        try {
            await axios.post(`/superadmin/plantillas-admin/${plantillaId}/duplicar`);
            setAlert({
                show: true,
                type: 'success',
                message: 'Plantilla duplicada exitosamente'
            });
            fetchPlantillas();
        } catch (error) {
            console.error('Error duplicating plantilla:', error);
            setAlert({
                show: true,
                type: 'danger',
                message: error.response?.data?.message || 'Error al duplicar la plantilla'
            });
        } finally {
            setTimeout(() => setAlert({ show: false, type: '', message: '' }), 5000);
        }
    };

    const handlePreview = (plantilla) => {
        setPlantillaToPreview(plantilla);
        setShowPreviewModal(true);
    };

    const getEspecialidadesUnicas = () => {
        const especialidades = plantillas
            .map(p => p.especialidad)
            .filter(e => e && e.trim() !== '');
        return [...new Set(especialidades)];
    };

    // Paginación
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredPlantillas.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredPlantillas.length / itemsPerPage);

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner-border text-info" role="status">
                    <span className="sr-only">Cargando...</span>
                </div>
            </div>
        );
    }

    return (
        <SuperadminLayout>
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h4><i className="fas fa-file-medical"></i> Plantillas de Historia Clínica</h4>
                                <div>
                                    <Link to="/superadmin/plantillas/crear-simple" className="btn btn-outline-info mr-2">
                                        <i className="fas fa-file-code"></i> Crear Plantilla Simple
                                    </Link>
                                    <Link to="/superadmin/plantillas/crear" className="btn btn-superadmin">
                                        <i className="fas fa-plus"></i> Crear Plantilla
                                    </Link>
                                </div>
                            </div>

                            {/* Alertas */}
                            {alert.show && (
                                <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
                                    {alert.message}
                                    <button type="button" className="close" onClick={() => setAlert({ show: false, type: '', message: '' })}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                            )}

                            {/* Filtros */}
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar por nombre..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <select
                                        className="form-control"
                                        value={especialidadFilter}
                                        onChange={(e) => setEspecialidadFilter(e.target.value)}
                                    >
                                        <option value="todos">Todas las especialidades</option>
                                        {getEspecialidadesUnicas().map((esp, index) => (
                                            <option key={index} value={esp}>{esp}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Tabla */}
                            <div className="table-responsive">
                                <table className="table table-hover superadmin-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Nombre</th>
                                            <th>Especialidad</th>
                                            <th>Clientes</th>
                                            <th>Fecha Creación</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.length > 0 ? (
                                            currentItems.map(plantilla => (
                                                <tr key={plantilla.id}>
                                                    <td>{plantilla.id}</td>
                                                    <td>{plantilla.nombre}</td>
                                                    <td>{plantilla.especialidad || <span className="text-muted">Sin especialidad</span>}</td>
                                                    <td>
                                                        <span className="badge badge-info">
                                                            {plantilla.clientes_asignados || 0}
                                                        </span>
                                                    </td>
                                                    <td>{new Date(plantilla.created_at).toLocaleDateString()}</td>
                                                    <td>
                                                        <Link
                                                            to={`/superadmin/plantillas/editar/${plantilla.id}`}
                                                            className="btn btn-sm btn-dark mr-1"
                                                            title="Editar"
                                                        >
                                                            <i className="fas fa-edit"></i>
                                                        </Link>
                                                        <Link
                                                            to={`/superadmin/plantillas/editar-simple/${plantilla.id}`}
                                                            className="btn btn-sm btn-outline-info mr-1"
                                                            title="Editar Simple (JSON)"
                                                        >
                                                            <i className="fas fa-file-code"></i>
                                                        </Link>
                                                        <button
                                                            className="btn btn-sm btn-secondary mr-1"
                                                            onClick={() => handleDuplicar(plantilla.id)}
                                                            title="Duplicar"
                                                        >
                                                            <i className="fas fa-copy"></i>
                                                        </button>
                                                        <Link
                                                            to={`/superadmin/plantillas/${plantilla.id}/asignar`}
                                                            className="btn btn-sm btn-success mr-1"
                                                            title="Asignar clientes"
                                                        >
                                                            <i className="fas fa-users"></i>
                                                        </Link>
                                                        <button
                                                            className="btn btn-sm btn-info mr-1"
                                                            onClick={() => handlePreview(plantilla)}
                                                            title="Vista previa"
                                                        >
                                                            <i className="fas fa-eye"></i>
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => handleDeleteClick(plantilla)}
                                                            title="Eliminar"
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center">
                                                    No se encontraron plantillas
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Paginación */}
                            {totalPages > 1 && (
                                <nav>
                                    <ul className="pagination justify-content-center">
                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            >
                                                Anterior
                                            </button>
                                        </li>
                                        {[...Array(totalPages)].map((_, index) => (
                                            <li
                                                key={index + 1}
                                                className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(index + 1)}
                                                >
                                                    {index + 1}
                                                </button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                            >
                                                Siguiente
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            )}
            {/* Modal de Confirmación Eliminar */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Eliminación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    ¿Está seguro que desea eliminar la plantilla <strong>{plantillaToDelete?.nombre}</strong>?
                    <br /><br />
                    <small className="text-danger">
                        Nota: Esta acción no afectará las copias ya asignadas a clientes.
                    </small>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="danger" onClick={handleDeleteConfirm}>
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Vista Previa */}
            <Modal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Vista Previa: {plantillaToPreview?.nombre}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {plantillaToPreview && (
                        <div>
                            <p><strong>Especialidad:</strong> {plantillaToPreview.especialidad || 'Sin especialidad'}</p>
                            <p><strong>Descripción:</strong> {plantillaToPreview.descripcion || 'Sin descripción'}</p>
                            <hr />
                            <h6>Estructura JSON:</h6>
                            <pre className="bg-light p-3" style={{ maxHeight: '400px', overflow: 'auto' }}>
                                {(() => {
                                    try {
                                        const raw = plantillaToPreview.estructura_json;
                                        let estructuraDisplay = null;
                                        if (typeof raw === 'string' && raw.trim() !== '') {
                                            estructuraDisplay = JSON.parse(raw);
                                        } else if (raw && typeof raw === 'object') {
                                            estructuraDisplay = raw;
                                        }
                                        return estructuraDisplay
                                            ? JSON.stringify(estructuraDisplay, null, 2)
                                            : 'Sin estructura definida';
                                    } catch (e) {
                                        return 'Sin estructura definida';
                                    }
                                })()}
                            </pre>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowPreviewModal(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </SuperadminLayout>
    );
};

export default PlantillasAdmin;
